import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PartService } from '../../service/api/part-service';

const initData = {
  moldInfoID: 0,
  CustomerId: 0,
  toolID: '',
  customerName: '',
  customerContact: '',
  customerEmail: '',
  customerPhone: '',
  moldNumber: '',
  moldDescription: '',
  partID: 0,
  description: '',
  materialType: '',
  cavity: '',
  shipmentDate: '',
  receivedDate: '',
  carrier: '',
  trackingNumber: '',
  conditionofShipment: '',
  inspectedBy: '',
  additionalPicture: [],
  noVisibleDamage: false,
  noRustOrCorrosion: false,
  properLabeling: false,
  moldWidth: 0,
  moldLength: 0,
  moldHeight: 0,
  functionalTest: false,
  functionalTestPicture: '',
  additionalComments: '',
  unloadingApproval: '',
  qualityControlApprovedBy: '',
  engineeringApprovedBy: '',
  submittedBy: '',
  moldDocuments: [],
};

const FutureActionsAddEditForm = ({
  data,
  onChanges,
  id,
  invalidFields = [],
  showValidation = false,
  isEditMode = false,
}) => {
  const [formData, setFormData] = useState(initData);
  const [partsList, setPartsList] = useState([]);
  const [isFieldsLocked, setIsFieldsLocked] = useState(false);

  useEffect(() => {
    if (data) {
      setFormData(data);
    }
  }, [data]);

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const response = await PartService.getAllPartsList();
        if (response?.response) {
          setPartsList(response.response);
        }
      } catch (error) {
        console.error('Error fetching parts list:', error);
      }
    };

    fetchParts();
  }, []);

  const updateFormField = (fieldName, value) => {
    if (isFieldsLocked) {
      return;
    }
    
    setFormData(prevData => {
      let processedValue;
      
      if (typeof value === 'function') {
        processedValue = value(prevData[fieldName]);
      } else {
        if (['moldWidth', 'moldHeight', 'moldLength'].includes(fieldName)) {
          processedValue = value === '' || value === null || value === undefined ? 0 : Math.round(parseFloat(value) * 100) || 0;
        } else {
          processedValue = value;
        }
      }
      
      const updatedData = {
        ...prevData,
        [fieldName]: processedValue,
      };
      
      onChanges(updatedData);
      
      return updatedData;
    });
  };

  const isFieldInvalid = (fieldName) => {
    return showValidation && invalidFields.includes(fieldName);
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">
            Tool ID <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${isFieldInvalid('toolID') ? 'is-invalid' : ''}`}
            value={formData.toolID || ''}
            onChange={(e) => updateFormField('toolID', e.target.value)}
            disabled={isFieldsLocked}
          />
          {isFieldInvalid('toolID') && (
            <div className="invalid-feedback">Tool ID is required</div>
          )}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">
            Customer Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${isFieldInvalid('customerName') ? 'is-invalid' : ''}`}
            value={formData.customerName || ''}
            onChange={(e) => updateFormField('customerName', e.target.value)}
            disabled={isFieldsLocked}
          />
          {isFieldInvalid('customerName') && (
            <div className="invalid-feedback">Customer Name is required</div>
          )}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">
            Mold Number <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${isFieldInvalid('moldNumber') ? 'is-invalid' : ''}`}
            value={formData.moldNumber || ''}
            onChange={(e) => updateFormField('moldNumber', e.target.value)}
            disabled={isFieldsLocked}
          />
          {isFieldInvalid('moldNumber') && (
            <div className="invalid-feedback">Mold Number is required</div>
          )}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">
            Description <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${isFieldInvalid('description') ? 'is-invalid' : ''}`}
            value={formData.description || ''}
            onChange={(e) => updateFormField('description', e.target.value)}
            disabled={isFieldsLocked}
          />
          {isFieldInvalid('description') && (
            <div className="invalid-feedback">Description is required</div>
          )}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">
            Received Date <span className="text-danger">*</span>
          </label>
          <input
            type="date"
            className={`form-control ${isFieldInvalid('receivedDate') ? 'is-invalid' : ''}`}
            value={formData.receivedDate || ''}
            onChange={(e) => updateFormField('receivedDate', e.target.value)}
            disabled={isFieldsLocked}
          />
          {isFieldInvalid('receivedDate') && (
            <div className="invalid-feedback">Received Date is required</div>
          )}
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">Material Type</label>
          <input
            type="text"
            className="form-control"
            value={formData.materialType || ''}
            onChange={(e) => updateFormField('materialType', e.target.value)}
            disabled={isFieldsLocked}
          />
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">Cavity</label>
          <input
            type="text"
            className="form-control"
            value={formData.cavity || ''}
            onChange={(e) => updateFormField('cavity', e.target.value)}
            disabled={isFieldsLocked}
          />
        </div>
      </div>

      <div className="col-md-6">
        <div className="mb-3">
          <label className="form-label">Carrier</label>
          <input
            type="text"
            className="form-control"
            value={formData.carrier || ''}
            onChange={(e) => updateFormField('carrier', e.target.value)}
            disabled={isFieldsLocked}
          />
        </div>
      </div>

      <div className="col-12">
        <div className="mb-3">
          <label className="form-label">Additional Comments</label>
          <textarea
            className="form-control"
            rows="3"
            value={formData.additionalComments || ''}
            onChange={(e) => updateFormField('additionalComments', e.target.value)}
            disabled={isFieldsLocked}
          />
        </div>
      </div>
    </div>
  );
};

export default FutureActionsAddEditForm;
